import React from "react";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";

const ProjectCardKauraTooltips = () => {
  return (
    <>
      <Box margin={1}>
        <Typography align='center' variant='subtitle1'>
          Techstack
        </Typography>
      </Box>

      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={0}>
          <Typography variant='subtitle2'>Landing Pages: Gatsby, Antd</Typography>
        </Grid>

        <Grid container item xs={12} spacing={0}>
          <Typography variant='subtitle2'>
            App: React, React-Router, React-Query, Netlify Serverless Functions, Zustand, Material-UI, Chart.js, Formik,
            React-Beautiful-Dnd(rbd)
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default ProjectCardKauraTooltips;
